const DEFAULT_PERIVERSE_API_URL = 'http://localhost:3000';

const isTemplatePlaceholder = (value?: string | null): boolean => {
  if (!value) {
    return false;
  }

  return value.startsWith('${') && value.endsWith('}');
};

/**
 * Resolve the backend API base URL.
 * Priority: window.__RUNTIME_CONFIG__ > import.meta.env > process.env > fallback
 */
export const resolvePeriverseApiBaseUrl = (): string => {
  if (typeof window !== 'undefined') {
    const runtimeValue = (window as any).__RUNTIME_CONFIG__
      ?.VITE_PERIVERSE_API_URL;

    if (
      runtimeValue &&
      runtimeValue.trim() !== '' &&
      !isTemplatePlaceholder(runtimeValue)
    ) {
      return runtimeValue;
    }
  }

  const importMetaEnv = (globalThis as any).import?.meta?.env;
  const viteValue = importMetaEnv?.VITE_PERIVERSE_API_URL;

  if (typeof viteValue === 'string' && viteValue.trim() !== '') {
    return viteValue;
  }

  if (typeof process !== 'undefined') {
    const processValue = process.env?.['VITE_PERIVERSE_API_URL'];

    if (processValue && processValue.trim() !== '') {
      return processValue;
    }
  }

  return DEFAULT_PERIVERSE_API_URL;
};

export const __testUtils = {
  DEFAULT_PERIVERSE_API_URL,
  isTemplatePlaceholder,
};
